"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSpaces = addSpaces;
exports.addSpacesAndCapitalize = addSpacesAndCapitalize;
exports.addSpacesAndLowerCase = addSpacesAndLowerCase;
exports.capitalize = capitalize;
exports.excerpt = excerpt;
exports.getIndefiniteArticle = getIndefiniteArticle;
exports.implode = implode;

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function implode(arr) {
  return arr.join(', ');
}

function excerpt(text, limit) {
  return text.length > limit ? "".concat(text.substring(0, limit), "...") : text;
}

function addSpaces(text) {
  return text.replace(/([A-Z])/g, ' $1').trim();
}

function addSpacesAndLowerCase(text) {
  return addSpaces(text).toLowerCase();
}

function addSpacesAndCapitalize(text) {
  return capitalize(addSpaces(text).toLowerCase());
}

function getIndefiniteArticle(text) {
  return ['a', 'e', 'i', 'o'].includes(text[0].toLowerCase()) ? 'an' : 'a';
}